/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRecommendationsViewResponse {
    getFixupPrototypeFunction() { return ListRecommendationsViewResponse.fixupPrototype; }

    static newInstance(model: Partial<ListRecommendationsViewResponse>): ListRecommendationsViewResponse {
        let obj = Object.assign(new ListRecommendationsViewResponse(), model);
        ListRecommendationsViewResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRecommendationsViewResponse>): ListRecommendationsViewResponse {
        if (!model) return null;
        return ListRecommendationsViewResponse.newInstance(<ListRecommendationsViewResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRecommendationsViewResponse) {
        if (!obj) return;

        models.ListRecommendationsViewResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRecommendationsViewResponse): boolean {
        Object.setPrototypeOf(obj, ListRecommendationsViewResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.resource_counts) {
            models.ResourceCount.fixupPrototype(this.resource_counts);
        }
        if (this.cost_savings) {
            models.CostSavings.fixupPrototype(this.cost_savings);
        }
    }

    /**
     * Recommendation id
     */
    id: string;

    /**
     * Policy Id
     */
    policy_id: string;

    /**
     * Policy Name
     */
    policy_name: string;

    /**
     * Name
     */
    name: string;

    /**
     * Status
     */
    status: string;

    /**
     * Impact based on recommendation
     */
    impact: string;

    /**
     * Classification
     */
    classification: string;

    /**
     * Sub Classification based on classification
     */
    sub_classification: string;

    /**
     * Cloud account id
     */
    cloud_account_id: string;

    /**
     * Cloud Account Name
     */
    cloud_account_name: string;

    /**
     * Tenant Name
     */
    tenant_name: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Cloud Service Name
     */
    service_name: string;

    /**
     * Source
     */
    source: string;

    /**
     * Time of creation
     */
    created_at: string;

    /**
     * Projected Cost Saving per Month
     */
    projected_cost_savings_month: string;

    /**
     * The resources that are open based on recommendation
     */
    resource_counts: models.ResourceCount;

    /**
     * Description
     */
    description: string;

    /**
     * Cost Saving based on recommendation
     */
    cost_savings: models.CostSavings;

    /**
     * Total Count
     */
    total_count: number;

    /**
     * Page Count
     */
    page_count: number;

    /**
     * Resources
     */
    resources: Array<any>;

}
